import React from 'react';
import Card from '../../../../components/LazyWidgets/Card';
import sectionManagerImage from './sectionmanager.png';
import s from './styles.module.css';

const SectionManagerMessage = () => (
  <Card className={s.sectionManagerCard}>
    <div className={s.leftCol}>
      <img
        width="192"
        height="105"
        className={s.sectionManagerGraphic}
        src={sectionManagerImage}
        alt="section manager graphic"
      />
    </div>
    <div className={s.rightCol}>
      <div className={s.sectionManagerTitle}>Reports are available in Course Sections</div>
      <div className={s.sectionManagerText}>You can view reports on each individual course by entering and viewing each course section.</div>
    </div>
  </Card>
);

export default SectionManagerMessage;
